module.exports = __webpack_public_path__ + "img/3.6.CODm.cf79d630.png";